const prepareFilterFormIndices = (form) => {
    const configuration = form.querySelector('.filter-configuration');

    if (!configuration) {
        return;
    }

    let groupCounter = 0;

    configuration.querySelectorAll('.filter-group').forEach((filterGroup) => {
        let filterCounter = 0;

        filterGroup.querySelectorAll('.automation-filter').forEach((automationFilter) => {
            const filterType = automationFilter.querySelector('[name="filterFields"]');
            const operator   = automationFilter.querySelector('[name="operator"]');

            if (!filterType || !operator) {
                filterCounter++;

                return;
            }

            filterType.setAttribute('name', `groups[${groupCounter}][filters][${filterCounter}][type]`);
            operator.setAttribute('name', `groups[${groupCounter}][filters][${filterCounter}][operator]`);

            const keyField = automationFilter.querySelector('.key-field [name="key"]');

            if (keyField) {
                keyField.setAttribute('name', `groups[${groupCounter}][filters][${filterCounter}][key]`);
            }

            const scopeField = automationFilter.querySelector('.key-field [name="scope"]');

            if (scopeField) {
                scopeField.setAttribute(
                    'name',
                    `groups[${groupCounter}][filters][${filterCounter}][scope]`,
                );
            }

            automationFilter.querySelectorAll('.key-field [name="keyArguments[]"]').forEach((argument) => {
                argument.setAttribute(
                    'name',
                    `groups[${groupCounter}][filters][${filterCounter}][keyArguments][]`,
                );
            });

            const valueScope = automationFilter.querySelector('.condition:not(.key-field) [name="scope"]');

            if (valueScope) {
                valueScope.setAttribute(
                    'name',
                    `groups[${groupCounter}][filters][${filterCounter}][scope]`,
                );
            }

            const value = operator.closest('.condition')?.children[1];

            if (!value) {
                filterCounter++;

                return;
            }

            if (value.dataset.compoundValue) {
                value.querySelectorAll('[name]').forEach((part) => {
                    part.setAttribute(
                        'name',
                        `groups[${groupCounter}][filters][${filterCounter}][${part.name.replace('[', '][')}`,
                    );
                });

                filterCounter++;

                return;
            }

            let field;

            if (value.classList.contains('select-container')) {
                field = value.querySelector('select');
            } else if (value.classList.contains('editable-tags')) {
                field = value.querySelector('select');
            } else if (value.tagName === 'INPUT') {
                field = value;
            } else {
                field = value.querySelector('input');
            }

            const baseName = field.name.replace(/\[\]$/, '');
            const suffix   = field.multiple ? '[]' : '';

            field.setAttribute(
                'name',
                `groups[${groupCounter}][filters][${filterCounter}][${baseName}]${suffix}`,
            );

            filterCounter++;
        });

        groupCounter++;
    });
};

const prepareGroupMatchIndices = (form) => {
    const configuration = form.querySelector('.filter-configuration');

    if (!configuration) {
        return;
    }

    cleanupGeneratedInputs(form);

    let groupCounter = 0;

    configuration.querySelectorAll('.filter-group').forEach((filterGroup) => {
        const matchInput         = document.createElement('input');
        matchInput.type          = 'hidden';
        matchInput.name          = `groups[${groupCounter}][match]`;
        matchInput.value         = filterGroup.dataset.match || 'all';
        matchInput.dataset.generated = 'true';

        filterGroup.appendChild(matchInput);

        groupCounter++;
    });

    const configMatchInput         = document.createElement('input');
    configMatchInput.type          = 'hidden';
    configMatchInput.name          = 'filterMatch';
    configMatchInput.value         = configuration.dataset.match || 'all';
    configMatchInput.dataset.generated = 'true';

    configuration.appendChild(configMatchInput);
};

const cleanupGeneratedInputs = (form) => {
    form.querySelectorAll('[data-generated="true"]').forEach(input => input.remove());
};

const prepareActionFormIndices = (form) => {
    let formCounter = 0;

    form.querySelectorAll('.action-section .automation-action').forEach((automationAction) => {
        automationAction.querySelectorAll('select, input, textarea').forEach((inputElement) => {
            if ('actionType' in inputElement.dataset) {
                inputElement.setAttribute('name', `forms[${formCounter}][type]`);

                return;
            }

            if ('integrationStub' in inputElement.dataset) {
                inputElement.setAttribute('name', `forms[${formCounter}][integrationStub]`);

                return;
            }

            if (!('fieldName' in inputElement.dataset)) {
                inputElement.dataset.fieldName = inputElement.getAttribute('name');
            }

            const fieldName = inputElement.dataset.fieldName;
            const isList    = fieldName.endsWith('[]');
            const baseName  = isList ? fieldName.slice(0, -2) : fieldName;

            inputElement.setAttribute(
                'name',
                `forms[${formCounter}][fields][${baseName}]${isList ? '[]' : ''}`,
            );
        });

        formCounter++;
    });
};

export const prepareAutomationSubmission = (event) => {
    const form = event.detail.target.closest('#edit-automation')
        || event.detail.target.closest('#create-workflow-form')
        || event.detail.target.closest('#edit-workflow-filters-form');

    if (!form) {
        return;
    }

    prepareFilterFormIndices(form);
    prepareGroupMatchIndices(form);
    prepareActionFormIndices(form);

    event.detail.parameters = {};

    form.querySelectorAll('input, select, textarea').forEach((field) => {
        const name = field.getAttribute('name');

        if (name === null) {
            return;
        }

        if (field.type === 'checkbox') {
            event.detail.parameters[name] = field.checked ? '1' : '';

            return;
        }

        if (field.multiple) {
            event.detail.parameters[name] = [...field.selectedOptions].map(option => option.value);

            return;
        }

        if (name.endsWith('[]')) {
            (event.detail.parameters[name] ??= []).push(field.value);

            return;
        }

        event.detail.parameters[name] = field.value;
    });
};
